import { DestinationsListSkeletonLoaderWrapper } from './DestinationsListSkeletonLoader.styles';

const DestinationCardSkeleton = () => (
  <>
    <span className="seperator"></span>
    <div className="destinations-list-card">
      <div className="skeleton-loader destinations-list-card_image"></div>
      <div className="skeleton-loader destinations-list-card_text"></div>
    </div>
  </>
);

export const DestinationsListSkeletonLoader = ({ cardCount }: { cardCount: number }) => {
  return (
    <DestinationsListSkeletonLoaderWrapper className="container mt-5">
      <div className="skeleton-loader destinations-list-header"></div>
      <div className="destinations-list-container">
        {Array.from({ length: cardCount }, (_, index) => (
          <DestinationCardSkeleton key={index} />
        ))}
      </div>
    </DestinationsListSkeletonLoaderWrapper>
  );
};

export default DestinationsListSkeletonLoader;
